"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = void 0;
/**
 * Flatten a Sequelize model object to response data payload
 *
 * This prevents secret parameters of Sequelize being output to the API
 * (e.g. database table name, column name, etc)
 *
 * @param item
 */
function flatten(item) {
    const obj = Object.assign({}, item);
    return Object.assign(Object.assign({}, obj.dataValues), { links: obj.links || [] });
}
exports.flatten = flatten;
//# sourceMappingURL=response-data-item.js.map